import React, { Component } from 'react';
import PropTypes from 'prop-types';
import without from 'lodash/without';
import difference from 'lodash/difference';

import FormError from 'marketing-website/components/modules/FormError';
import FormErrorLink from 'marketing-website/components/modules/FormErrorLink';
import FormWrap from 'marketing-website/components/modules/FormWrap';
import { isEmailValid } from 'marketing-website/utils/forms';
import { fetchApi } from 'marketing-website/utils/fetch';
import { API_FORGOT_PASSWORD } from 'marketing-website/constants/api';

export default class ResetPasswordForm extends Component {
  static propTypes = {
    messaging: PropTypes.string.isRequired,
  };

  state = {
    backendErrorMsg: {},
    email: '',
    invalidFields: [],
    isPending: false,
    resetSuccessful: false,
    validFields: [],
  };

  setFieldValue = (e, fieldName) => {
    const value = e.target.value;
    let validFields = [];

    if (this.state.validFields.indexOf(fieldName) !== -1) {
      validFields = without(validFields, fieldName);
      this.setState({
        [fieldName]: value,
        validFields,
      });
    } else {
      this.setState({
        [fieldName]: value,
      });
    }
  };

  validateForm = e => {
    e.preventDefault();
    if (this.isFormValid()) {
      this.resetPassword();
    }
  };

  isFormValid = () => {
    const { email } = this.state;
    const invalidFields = [];

    if (!isEmailValid(email)) {
      invalidFields.push('email');
    }

    const validFields = difference(['email'], invalidFields);

    this.setState({
      invalidFields,
      backendErrorMsg: {},
      validFields,
    });

    return !invalidFields.length;
  };

  resetPassword = () => {
    const { email } = this.state;
    this.setState({ isPending: true });
    fetchApi('POST', API_FORGOT_PASSWORD, {
      email,
    })
      .then(() => {
        this.setState({
          resetSuccessful: true,
          isPending: false,
        });
      })
      .catch(this.displayServerError);
  };

  displayServerError = error => {
    const backendErrorMsg = getErrorMessage(error);
    this.setState({
      isPending: false,
      backendErrorMsg,
    });
  };

  render() {
    const {
      backendErrorMsg,
      isPending,
      invalidFields,
      validFields,
      resetSuccessful,
    } = this.state;

    const fields = [
      {
        errorMsg: 'Please enter a valid email address',
        label: 'Email address',
        name: 'email',
        placeholder: 'you@example.com',
        type: 'email',
      },
    ];

    const buttonProps = {
      text: 'Reset password',
    };

    const successMessage =
      "Password reset sent! You'll receive an email if you are registered on our system.";

    return (
      <FormWrap
        backendErrorMsg={backendErrorMsg}
        buttonProps={buttonProps}
        fields={fields}
        messaging={this.props.messaging}
        invalidFields={invalidFields}
        isPending={isPending}
        setFieldValue={this.setFieldValue}
        validateForm={this.validateForm}
        validFields={validFields}
        action={API_FORGOT_PASSWORD}
        formSuccess={resetSuccessful && successMessage}
      >
        <FormError {...backendErrorMsg} />
      </FormWrap>
    );
  }
}

function getErrorMessage() {
  return {
    message: (
      <span>
        There was an error resetting your password. Please try again or{' '}
        <FormErrorLink url="https://help.marvelapp.com/" isExternal>
          contact support
        </FormErrorLink>
        .
      </span>
    ),
  };
}



// WEBPACK FOOTER //
// ./src/components/modules/ForgotPasswordForm/index.js